<template>
    <div class="correct-data-container">
        <div class="card-container">
            <el-tabs v-model="activeTab" @tab-click="onTabClick">
                <el-tab-pane label="学院专业修正" name="1"></el-tab-pane>
                <el-tab-pane label="招生类型修正" name="2"></el-tab-pane>
                <el-tab-pane label="科类修正" name="3"></el-tab-pane>
                <el-tab-pane label="批次修正" name="4"></el-tab-pane>
                <el-tab-pane label="考生类别修正" name="5"></el-tab-pane>
                <el-tab-pane label="毕业类别修正" name="6"></el-tab-pane>
            </el-tabs>

            <div class="dict-content">
                <div class="toolbar">
                    <div class="search-box">
                        <el-button type="primary" icon="el-icon-edit" @click="handleBatchCorrect" :disabled="selection.length === 0">批量修正</el-button>
                        <el-button type="success" icon="el-icon-download" @click="handleExport">导出Excel</el-button>
                        <el-button v-if="activeTab === '1'" type="warning" icon="el-icon-magic-stick" @click="handleAutoCorrect">一键修正</el-button>
                    </div>
                </div>

                <div class="data-table">
                    <el-table 
                        :key="activeTab"
                        :data="tableData" 
                        border 
                        stripe
                        class="common-table" 
                        @selection-change="handleSelectionChange"
                        v-loading="loading"
                        :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                        empty-text="暂无数据"
                        height="calc(100vh - 340px)"
                        ref="table"
                        @filter-change="handleFilterChange">
                        <el-table-column type="selection" width="55" align="center" fixed="left"></el-table-column>
                        <el-table-column type="index" label="序号" width="60" align="center" fixed="left"></el-table-column>
                        
                        <!-- 动态列 -->
                        <el-table-column 
                            v-for="col in currentColumns" 
                            :key="col.prop" 
                            :prop="col.prop" 
                            :label="col.label" 
                            min-width="150"
                            align="center"
                            show-overflow-tooltip>
                            <template slot="header">
                                <span>{{col.label}}</span>
                                <table-column-filter :field="col.prop" :options="col.filters" :value="activeFilters[col.prop]" @filter-change="handleCustomFilter" />
                            </template>
                        </el-table-column>
                        
                        <el-table-column prop="RenShu" label="录取人数" width="100" align="center" sortable></el-table-column>

                        <el-table-column 
                            prop="OriginalName" 
                            :label="originalNameLabel" 
                            width="200"
                            align="center"
                            fixed="right"
                            show-overflow-tooltip>
                            <template slot="header">
                                <span>{{originalNameLabel}}</span>
                                <table-column-filter field="OriginalName" :options="getFilters('OriginalName')" :value="activeFilters['OriginalName']" @filter-change="handleCustomFilter" />
                            </template>
                            <template slot-scope="scope">
                                <span :class="{'text-danger': !scope.row.OriginalName}">{{ scope.row.OriginalName || '(空)' }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column 
                            prop="CorrectedName" 
                            :label="correctedNameLabel" 
                            width="200"
                            align="center"
                            fixed="right"
                            show-overflow-tooltip>
                            <template slot="header">
                                <span>{{correctedNameLabel}}</span>
                                <table-column-filter field="CorrectedName" :options="getFilters('CorrectedName')" :value="activeFilters['CorrectedName']" @filter-change="handleCustomFilter" />
                            </template>
                            <template slot-scope="scope">
                                <span :class="{'text-success': scope.row.CorrectedName, 'text-muted': !scope.row.CorrectedName}">{{ scope.row.CorrectedName || '(未修正)' }}</span>
                            </template>
                        </el-table-column>
                        
                        <el-table-column label="操作" width="100" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit" @click="handleCorrect(scope.row)">修正</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <!-- 修正弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" append-to-body>
            <div class="search-box" style="margin-bottom: 10px;">
                <el-input v-model="dictSearch" placeholder="搜索名称" style="width: 200px;" size="small" clearable @input="filterDictData"></el-input>
            </div>
            <div class="data-table" v-loading="dictLoading" style="min-height: 300px; max-height: 400px; overflow-y: auto;">
                <el-table 
                    :data="filteredDictList" 
                    border 
                    stripe
                    size="small" 
                    highlight-current-row 
                    @current-change="handleDictTableSelect"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                    
                    <el-table-column label="选择" width="60" align="center">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDictSN" :label="scope.row.SN" @change="selectDictItem(scope.row)"><span></span></el-radio>
                        </template>
                    </el-table-column>

                    <!-- 动态显示字典列 -->
                    <template v-if="activeTab === '1'">
                        <el-table-column prop="Name" label="校内专业名称" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="ParentName" label="学院名称" width="150" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="DaiMa" label="匹配专业名称" width="150" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="ZiDuan2" label="层次" width="80" align="center"></el-table-column>
                        <el-table-column prop="ZiDuan3" label="学制" width="80" align="center"></el-table-column>
                    </template>
                    
                    <template v-else-if="activeTab === '2'">
                        <el-table-column prop="Name" label="招生类型名称" min-width="150" align="center"></el-table-column>
                        <el-table-column prop="ZiDuan2" label="层次" width="100" align="center"></el-table-column>
                    </template>

                    <template v-else-if="activeTab === '3'">
                        <el-table-column prop="Name" label="科类名称" min-width="150" align="center"></el-table-column>
                    </template>

                    <template v-else-if="activeTab === '4'">
                        <el-table-column prop="Name" label="批次名称" min-width="150" align="center"></el-table-column>
                    </template>

                    <template v-else-if="activeTab === '5'">
                        <el-table-column prop="Name" label="考生类别名称" min-width="150" align="center"></el-table-column>
                    </template>

                    <template v-else-if="activeTab === '6'">
                        <el-table-column prop="Name" label="毕业类别名称" min-width="150" align="center"></el-table-column>
                    </template>

                </el-table>
            </div>

            <!-- 自定义输入区域 -->
            <div v-if="['3', '4', '5', '6'].includes(activeTab)" style="margin-top: 15px; padding: 10px; background-color: #f5f7fa; border-radius: 4px;">
                <div style="font-size: 13px; color: #606266; margin-bottom: 5px; font-weight: bold;">自定义修正值：</div>
                <div style="display: flex; align-items: center; gap: 10px;">
                    <el-input v-model="customValue" placeholder="如果上方列表中没有合适的选项，请在此处直接输入修正后的名称" size="small" style="flex: 1;" clearable></el-input>
                    <el-tooltip content="优先使用此处输入的值作为修正结果，清空后则使用上方列表中选中的项" placement="top">
                        <i class="el-icon-question" style="color: #909399; cursor: help;"></i>
                    </el-tooltip>
                </div>
                <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                    说明：您可以直接从上方列表中选择标准名称，也可以在此处手动输入新的名称。手动输入的值优先级高于列表选择。
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmCorrect" :disabled="!selectedDictSN && !customValue">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools';
    import TableColumnFilter from '../Shared/TableColumnFilter.vue';

    export default {
        name: 'CorrectData',
        components: {
            TableColumnFilter
        },
        inject: ['getCurrentYear'],
        data() {
            return {
                currentYear: '',
                activeTab: '1',
                tableData: [],
                loading: false,
                selection: [],
                
                // 弹窗相关
                dialogVisible: false,
                dictLoading: false,
                dictList: [], // 原始列表数据
                filteredDictList: [], // 过滤后的列表数据
                selectedDictItem: null, // 选中的字典项
                selectedDictSN: '', // 选中的字典项SN（用于radio绑定，避免对象引用问题）
                customValue: '', // 用户输入的自定义值
                targetRows: [], // 当前要修正的行（单行或多行）
                dictSearch: '', // 字典搜索关键词
                
                // 筛选相关
                rawTableData: [], // 原始全量数据
                activeFilters: {}, // 当前激活的筛选条件 { prop: [values] }

                tableHeaderStyle: {
                    backgroundColor: '#f5f7fa',
                    color: '#606266',
                    fontWeight: '600',
                    borderBottom: '1px solid #dfe6ec'
                }
            };
        },
        computed: {
            baseColumns() {
                switch (this.activeTab) {
                    case '1': // 学院专业
                        return [
                            { prop: 'G_XYMC', label: '学院' },
                            { prop: 'LQZY', label: '专业代码' },
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'XZ_ZSLXMC', label: '招生类型' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'XZ_KLMC', label: '科类' },
                            { prop: 'XZ_PCMC', label: '批次' }
                        ];
                    case '2': // 招生类型
                        return [
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'TDDWMC', label: '投档单位' },
                            { prop: 'XZ_KLMC', label: '科类' },
                            { prop: 'XZ_PCMC', label: '批次' },
                            { prop: 'XZ_ZYMC', label: '专业名称' }
                        ];
                    case '3': // 科类
                        return [
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'XZ_ZSLXMC', label: '招生类型' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'JHLBMC', label: '计划类别' },
                            { prop: 'TDDWMC', label: '投档单位' },
                            { prop: 'XZ_ZYMC', label: '专业名称' }
                        ];
                    case '4': // 批次
                        return [
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'XZ_ZSLXMC', label: '招生类型' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'XZ_KLMC', label: '科类' },
                            { prop: 'TDDWMC', label: '投档单位' },
                            { prop: 'XZ_ZYMC', label: '专业名称' }
                        ];
                    case '5': // 考生类别
                        return [
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'XZ_ZSLXMC', label: '招生类型' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'XZ_PCMC', label: '批次' }
                        ];
                    case '6': // 毕业类别
                        return [
                            { prop: 'CCMC', label: '层次' },
                            { prop: 'XZ_ZSLXMC', label: '招生类型' },
                            { prop: 'G_Sheng', label: '省份' },
                            { prop: 'XZ_PCMC', label: '批次' }
                        ];
                    default:
                        return [];
                }
            },
            currentColumns() {
                // Add filters to base columns
                return this.baseColumns.map(col => ({
                    ...col,
                    filters: this.getFilters(col.prop)
                }));
            },
            originalNameLabel() {
                const map = {
                    '1': '专业名称(原始)',
                    '2': '招生类型(原始)',
                    '3': '科类(原始)',
                    '4': '批次(原始)',
                    '5': '考生类别(原始)',
                    '6': '毕业类别(原始)'
                };
                return map[this.activeTab] || '原始名称';
            },
            correctedNameLabel() {
                const map = {
                    '1': '专业名称(修正后)',
                    '2': '招生类型(修正后)',
                    '3': '科类(修正后)',
                    '4': '批次(修正后)',
                    '5': '考生类别(修正后)',
                    '6': '毕业类别(修正后)'
                };
                return map[this.activeTab] || '修正后名称';
            },
            dialogTitle() {
                const map = {
                    '1': '修正学院专业',
                    '2': '修正招生类型',
                    '3': '修正科类',
                    '4': '修正批次',
                    '5': '修正考生类别',
                    '6': '修正毕业类别'
                };
                return map[this.activeTab] || '修正数据';
            }
        },
        mounted() {
            // 尝试获取年份，优先使用 inject 的方法，如果不行则尝试 $root.currentYear
            if (this.getCurrentYear) {
                this.currentYear = this.getCurrentYear();
            } else {
                this.currentYear = this.$root.currentYear;
            }
            
            if (this.currentYear) {
                this.loadData();
            }
            this.$root.$on('global-year-change', this.handleYearChange);
        },
        beforeDestroy() {
            this.$root.$off('global-year-change', this.handleYearChange);
        },
        methods: {
            handleYearChange(year) {
                this.currentYear = year;
                this.loadData();
            },
            onTabClick() {
                this.tableData = [];
                this.selection = [];
                this.loadData();
            },
            handleSelectionChange(val) {
                this.selection = val;
            },
            loadData() {
                if (!this.currentYear) return;
                
                this.loading = true;
                const api_name = '/Dict/GetCorrectData';
                const url = TYBM_Env.GetApiUrl(api_name) + `?CorrectionType=${this.activeTab}&Year=${this.currentYear}`;

                TYBM_Tools.AxiosGetEx(this, api_name, url, { loading_msg: '加载数据中...' })
                    .then(res => {
                        this.loading = false;
                        if (res.code == 'ok') {
                            this.rawTableData = res.data;
                            this.activeFilters = {}; // 重置筛选
                            this.applyFilters();
                        } else {
                            this.$message.error(res.errmsg || res.msg || '加载失败');
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            getFilters(prop) {
                if (!this.rawTableData || this.rawTableData.length === 0) return [];
                const values = new Set();
                this.rawTableData.forEach(row => {
                    const val = row[prop];
                    if (val !== null && val !== undefined && val !== '') {
                        values.add(val);
                    }
                });
                return Array.from(values).sort().map(val => ({ text: val, value: val }));
            },
            handleCustomFilter({ field, values }) {
                if (values && values.length > 0) {
                    this.$set(this.activeFilters, field, values);
                } else {
                    this.$delete(this.activeFilters, field);
                }
                this.applyFilters();
            },
            applyFilters() {
                let result = this.rawTableData;
                
                Object.keys(this.activeFilters).forEach(key => {
                    const values = this.activeFilters[key];
                    if (values && values.length > 0) {
                        result = result.filter(row => values.includes(row[key]));
                    }
                });
                
                this.tableData = result;
                
                // 重新布局
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        this.$refs.table.doLayout();
                    }
                });
            },
            handleCorrect(row) {
                this.targetRows = [row];
                this.openDialog();
            },
            handleBatchCorrect() {
                this.targetRows = this.selection;
                this.openDialog();
            },
            openDialog() {
                this.dialogVisible = true;
                this.selectedDictItem = null;
                this.selectedDictSN = '';
                this.dictSearch = '';
                this.customValue = '';
                
                // 如果是学院专业，且只选中了一行，预填充搜索框为原始名称
                if (this.activeTab === '1' && this.targetRows.length === 1) {
                    this.dictSearch = this.targetRows[0].OriginalName || '';
                }

                this.loadDictData();
            },
            loadDictData() {
                this.dictLoading = true;
                this.dictList = [];
                this.filteredDictList = [];
                
                let dictType = '';
                switch (this.activeTab) {
                    case '1': dictType = 'XYZY'; break;
                    case '2': dictType = 'ZSLX'; break;
                    case '3': dictType = 'KL'; break;
                    case '4': dictType = 'PC'; break;
                    case '5': dictType = 'KSLB'; break;
                    case '6': dictType = 'BYLB'; break;
                }
                
                const api_name = '/Dict/GetDictList';
                const url = TYBM_Env.GetApiUrl(api_name) + `?Type=${encodeURIComponent(dictType)}`;

                TYBM_Tools.AxiosGetEx(this, api_name, url, { hide_tip: true })
                    .then(res => {
                        this.dictLoading = false;
                        if (res.code == 'ok') { 
                            let data = res.data;
                            if (this.activeTab === '1') {
                                // 学院专业特殊处理：扁平化，只保留专业，并关联学院名称
                                this.processAcademyData(data);
                            } else {
                                this.dictList = data;
                                this.filterDictData();
                            }
                        }
                    })
                    .catch(() => {
                        this.dictLoading = false;
                    });
            },
            processAcademyData(data) {
                // 1. 建立学院映射
                let academyMap = {};
                data.forEach(item => {
                    if (!item.ZiDuan1 || item.ZiDuan1 == 0 || item.ZiDuan1 == "0") {
                        academyMap[item.SN] = item.Name;
                    }
                });

                // 2. 筛选专业并关联学院名称
                let majors = [];
                data.forEach(item => {
                    if (item.ZiDuan1 && item.ZiDuan1 != 0 && item.ZiDuan1 != "0") {
                        item.ParentName = academyMap[item.ZiDuan1] || '';
                        majors.push(item);
                    }
                });

                this.dictList = majors;
                this.filterDictData();
            },
            filterDictData() {
                if (!this.dictSearch) {
                    this.filteredDictList = this.dictList;
                    this.selectedDictSN = '';
                    this.selectedDictItem = null;
                    return;
                }
                
                const lowerSearch = this.dictSearch.toLowerCase();
                this.filteredDictList = this.dictList.filter(item => {
                    // 匹配名称、代码或匹配专业名称
                    return (item.Name && item.Name.toLowerCase().includes(lowerSearch)) ||
                           (item.DaiMa && item.DaiMa.toLowerCase().includes(lowerSearch)) || 
                           (item.ParentName && item.ParentName.toLowerCase().includes(lowerSearch));
                });

                this.selectedDictSN = '';
                this.selectedDictItem = null;
            },
            selectDictItem(node) {
                this.selectedDictItem = node;
                this.selectedDictSN = node ? node.SN : '';
            },
            handleDictTableSelect(val) {
                if (val) {
                    this.selectedDictSN = val.SN;
                    this.selectedDictItem = val;
                    if (['3', '4', '5', '6'].includes(this.activeTab)) {
                        this.customValue = val.Name;
                    }
                }
            },
            confirmCorrect() {
                let newValue = '';
                let academyName = '';

                // 通过 selectedDictSN 查找 selectedDictItem，确保对象引用有效
                if (!this.selectedDictItem && this.selectedDictSN) {
                    this.selectedDictItem = this.dictList.find(item => item.SN === this.selectedDictSN);
                }
                
                // 对于支持自定义输入的Tab
                if (['3', '4', '5', '6'].includes(this.activeTab)) {
                    // 优先使用customValue
                    if (this.customValue) {
                        newValue = this.customValue;
                    } else if (this.selectedDictItem) {
                        newValue = this.selectedDictItem.Name;
                    } else {
                        this.$message.warning('请选择修正值或输入自定义名称');
                        return;
                    }
                } else {
                    // 其他Tab必须选择字典项
                    if (!this.selectedDictItem) {
                        this.$message.warning('请选择修正值');
                        return;
                    }
                    // 学院专业修正：用 DaiMa（匹配专业名称），其他用 Name
                    if (this.activeTab === '1') {
                        newValue = this.selectedDictItem.DaiMa || this.selectedDictItem.Name;
                        academyName = this.selectedDictItem.ParentName || '';
                    } else {
                        newValue = this.selectedDictItem.Name;
                    }
                }
                
                const payload = {
                    CorrectionType: this.activeTab,
                    Year: this.currentYear,
                    NewValue: newValue,
                    AcademyName: academyName,
                    Groups: this.targetRows
                };
                
                const api_name = '/Dict/UpdateCorrectData';
                const url = TYBM_Env.GetApiUrl(api_name);

                TYBM_Tools.AxiosPostEx(this, api_name, url, { Model: JSON.stringify(payload) }, { loading_msg: '正在保存...', has_progress: false })
                    .then(res => {
                        if (res.code == 'ok') {
                            this.$message.success(`成功修正 ${res.count} 条记录`);
                            this.dialogVisible = false;
                            this.loadData();
                        } else {
                            this.$message.error(res.errmsg || res.msg);
                        }
                    });
            },
            handleExport() {
                if (this.tableData.length === 0) {
                    this.$message.warning('没有数据可导出');
                    return;
                }

                let csvContent = "\uFEFF"; 
                
                let headers = ["序号"];
                this.baseColumns.forEach(col => headers.push(col.label));
                headers.push("录取人数", this.originalNameLabel, this.correctedNameLabel);
                csvContent += headers.join(",") + "\n";
                
                this.tableData.forEach((row, index) => {
                    let rowData = [(index + 1).toString()];
                    this.baseColumns.forEach(col => {
                        let val = row[col.prop] || '';
                        val = val.toString().replace(/"/g, '""');
                        if (val.indexOf(',') > -1 || val.indexOf('\n') > -1) {
                            val = `"${val}"`;
                        }
                        rowData.push(val);
                    });
                    
                    rowData.push(row.RenShu);

                    let original = (row.OriginalName || '').replace(/"/g, '""');
                    let corrected = (row.CorrectedName || '').replace(/"/g, '""');
                    if (original.indexOf(',') > -1) original = `"${original}"`;
                    if (corrected.indexOf(',') > -1) corrected = `"${corrected}"`;
                    
                    rowData.push(original, corrected);
                    
                    csvContent += rowData.join(",") + "\n";
                });
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                const titleMap = {'1': '学院专业', '2': '招生类型', '3': '科类', '4': '批次', '5': '考生类别', '6': '毕业类别'};
                link.setAttribute("download", `${titleMap[this.activeTab]}修正数据_${this.currentYear}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            handleFilterChange() {
                // 筛选后重新布局，确保固定列对齐，配合CSS强制高度解决错位问题
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        this.$refs.table.doLayout();
                    }
                });
            },
            handleAutoCorrect() {
                this.$confirm(
                    '<div style="line-height: 1.8;">' +
                    '<p style="font-weight: bold; margin-bottom: 10px;">一键修正操作说明：</p>' +
                    '<p>1. 系统将遍历所有"专业名称（修正后）"为空的考生</p>' +
                    '<p>2. 使用考生的"专业名称"匹配学院专业表中的"匹配专业名称"</p>' +
                    '<p>3. 如果匹配成功，将自动设置考生的"专业名称（修正后）"和"学院"</p>' +
                    '<p>4. 匹配失败的考生将被跳过，需要手动修正</p>' +
                    '<p style="margin-top: 15px; color: #E6A23C; font-weight: bold;">此操作将批量修改数据，是否继续？</p>' +
                    '</div>',
                    '确认执行一键修正',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        customClass: 'auto-correct-confirm'
                    }
                ).then(() => {
                    const api_name = '/Dict/BatchAutoCorrectMajor';
                    const url = TYBM_Env.GetApiUrl(api_name) + '?Year=' + this.currentYear;
                    
                    TYBM_Tools.AxiosGetEx(this, api_name, url, { loading_msg: '正在执行一键修正...' })
                        .then(res => {
                            if (res.code == 'ok') {
                                this.$alert(res.resultMsg, '修正完成', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    dangerouslyUseHTMLString: true
                                });
                                this.loadData();
                            } else {
                                this.$message.error(res.errmsg || res.msg);
                            }
                        });
                }).catch(() => {
                    // 用户取消操作
                });
            }
        }
    }
</script>

<style scoped>
.dict-content {
    padding: 20px 0;
}

.toolbar {
    margin-bottom: 20px;
}

.search-box {
    display: flex;
    gap: 12px;
    align-items: center;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table >>> .el-table {
    font-size: 13px;
}

.data-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

.data-table >>> .el-table th {
    padding: 0 !important;
    height: 40px !important;
    background-color: #f5f7fa !important;
}

/* 强制每行高度一致 */
.data-table >>> .el-table__row {
    height: 40px !important;
}

/* 单元格内容控制 */
.data-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

/* 表头单元格特殊处理：使用 Flex 布局垂直居中，防止图标撑开 */
.data-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.text-danger {
    color: #f56c6c;
}

.text-success {
    color: #67c23a;
}

.text-muted {
    color: #909399;
}

/* 一键修正确认弹窗样式 */
.auto-correct-confirm >>> .el-message-box__message {
    font-size: 14px;
}

.auto-correct-confirm >>> .el-message-box__message p {
    margin: 5px 0;
}
</style>